/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "מימין לשמאל",
		"timeZoneID": "אזור זמן",
		"skin": "סגנון",
		"metricsFileImportTask": "יבוא חדש מתוך Files",
		"displayMode": "תצוגה מחדלית",
		"credentialRenewed": "ההסמכות שלכם חודשו עם זיהוי המשתמש והסיסמה הנוכחיים שלכם.",
		"productLocale": "שפת מוצר",
		"credentialChange": "חידוש",
		"log_level_Debug": "ניפוי",
		"confirmNewPassword": "אישור סיסמה חדשה",
		"educationPortalErrorMessage": "נסו שוב.  אם הבעיה נמשכת, פנו אל המנהלן.‏",
		"legalText": "Licensed Materials - Property of IBM Corp.‎ © Copyright IBM Corporation and other(s) 2005, 2017.‎ IBM, the IBM logo, ibm.com and Cognos are trademarks or registered trademarks of International Business Machines Corp., registered in many jurisdictions worldwide.‎ A current list of IBM trademarks is available on the Web at www.ibm.com/legal/copytrade.shtml.‎ תוכנית זו היא ברשיון בכפוף לתנאי הסכם הרשיון שמצורף לתוכנית. הסכם רישיון זה עשוי להיות ממוקם בתיקיית תוכנית או בספריה המזוהה בתור  \"License\" או \"Non_IBM_License\",‏  אם רלוונטי, או להיות מסופק כהסכם רישיון מודפס. קראו את ההסכם בקפידה לפני השימוש בתוכנית. השימוש בתוכנית מהווה הסכמה לתנאים אלה.",
		"groupsAndRoles": "קבוצות ותפקידים",
		"metricsMaintenanceTask": "תחזוקה חדשה",
		"email": "דואל",
		"contextual": "לפי הקשר",
		"resetHome": "החזרה לברירת מחדל",
		"ltr": "משמאל לימין",
		"credentials": "הסמכות",
		"logging_congfig_title": "רישום ביומן",
		"changePasswordTitle": "שינוי הסיסמה שלי",
		"format": "מבנה דוח",
		"showUnread": "הצגת פריטים שלא נקראו",
		"homeSetError": "אירעה שגיאה בהגדרת דף הבית המחדלי, נסו לסגור ופתוח תצוגה זו שוב.",
		"passwordChange": "שינוי הסיסמה שלכם",
		"knowledgeCenterErrorTitle": "הקישור למרכז הידע לא פעל",
		"drillThrough": "הגדרות Drill-Through",
		"homeSet": "דף הבית שלכם הוגדר בהצלחה",
		"regionalOptions": "אפשרויות עבור האזור שלכם",
		"educationPortalErrorTitle": "הקישור לפורטל החינוך לא פעל",
		"myPreferences": "ההעדפות שלי",
		"defaultHome": "ברירת מחדל",
		"version": "גרסה",
		"controller": "בקר",
		"manage": "ניהול",
		"biDirectionalFeaturesEnabled": "תמיכה בשפות דו-כיווניות",
		"passwordMatch": "זהות סיסמאות",
		"dashboardConsole": "Workspace",
		"legacyAppsSlideoutLabel": "יישומים זמינים מגרסאות קודמות",
		"logging_config_description": "רישום ביומן משמש לפתרון בעיות. פנו למנהלן כדי לקבל הנחיות בנוגע להגדרות.",
		"dataSourceCredentials": "הסמכות שרת נתונים",
		"advanced": "מתקדם",
		"ok": "אישור",
		"showHints": "הצגת רמזים",
		"general": "כללי",
		"xlsxData": "נתוני Excel",
		"personal": "אישי",
		"newPassword": "סיסמה חדשה",
		"confirmPassword": "אישור סיסמה",
		"hideAll": "הסתרת הכל",
		"metricStudio": "סטודיו",
		"log_level_Warn": "אזהרה",
		"myCapabilities": "היכולות שלי",
		"homePage": "דף הבית",
		"portal": "פורטל",
		"metricsPackage": "מארז חדש",
		"myCredentials": "ההסמכות שלי",
		"credentialCreate": "יצירה",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "לא ניתן לעדכן את הסיסמה.",
		"csv": "CSV",
		"showHiddenObjects": "הצגת רשומות מוסתרות",
		"log_level_Error": "שגיאה",
		"wrongPassword": "לא ניתן לאמת.",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "מידע",
		"contentLocale": "שפת תוכן",
		"pdf": "PDF",
		"oldPassword": "סיסמה ישנה",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "הפעלת מאפייני נגישות",
		"manageLogging": "רישום ביומן",
		"loggingConfigurationSlideoutA11yLabel": "תצורת רישום ביומן",
		"communityErrorTitle": "הקישור לקהילה לא פעל",
		"companionApps": "יישומים נלווים",
		"metricsExportTask": "יצוא חדש",
		"contributor": "תורם",
		"showAll": "הצגת הכל",
		"logging_active": "רישום ביומן מופעל:",
		"baseTextDirection": "כיוון תמליל בסיסי",
		"html": "HTML",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "סיסמה",
		"credentialCreateSuccess": "יצרתם את ההסמכות שלכם בהצלחה",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "הצגת פרטים",
		"showPassword": "הצגת סיסמה",
		"myPreferencesSlideoutLabel": "ההעדפות שלי",
		"passWordChangeSuccess": "שיניתם את סיסמתכם בהצלחה",
		"logging_level": "רמת רישום ביומן:",
		"analysisStudio": "Analysis Studio",
		"knowledgeCenterErrorMessage": "נסו שוב.  אם הבעיה נמשכת, פנו אל המנהלן.‏",
		"communityErrorMessage": "נסו שוב.  אם הבעיה נמשכת, פנו אל המנהלן.‏",
		"cancel": "ביטול",
		"shareSetError": "ניתן לבצע פעולה זו רק לאחר סגירת תצוגה זו ופתיחתה מחדש.",
		"passwordNotMatch": "שגיאה, הסיסמה אינן זהות"
});